import React from 'react'
import { createPortal } from 'react-dom'

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  isDangerous = false,
}) => {
  if (!isOpen) return null

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  const modal = (
    <div
      className="tw-fixed tw-inset-0 tw-z-[10050] tw-flex tw-items-center tw-justify-center tw-bg-black tw-bg-opacity-50"
      onClick={handleBackdropClick}
      role="presentation"
    >
      <div
        className="tw-bg-white tw-rounded-lg tw-shadow-xl tw-max-w-md tw-w-full tw-mx-4"
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="tw-px-6 tw-py-4 tw-border-b tw-border-gray-200">
          <h3 id="confirm-modal-title" className="tw-text-lg tw-font-medium tw-text-gray-900">
            {title}
          </h3>
        </div>

        <div className="tw-px-6 tw-py-4">
          <p className="tw-text-sm tw-text-gray-600">{message}</p>
        </div>

        <div className="tw-px-6 tw-py-4 tw-border-t tw-border-gray-200 tw-flex tw-justify-end tw-space-x-3">
          <button
            type="button"
            onClick={onClose}
            className="tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-gray-700 tw-bg-white tw-border tw-border-gray-300 tw-rounded-md hover:tw-bg-gray-50 tw-transition-colors"
          >
            {cancelText}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={`tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-white tw-rounded-md tw-transition-colors ${
              isDangerous
                ? 'tw-bg-red-600 hover:tw-bg-red-700'
                : 'tw-bg-blue-600 hover:tw-bg-blue-700'
            }`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  )

  return createPortal(modal, document.body)
}

export default ConfirmModal
